/**
 * Rotating typing animation for header search placeholder ("Search for …").
 * Vanilla JS, single timer chain; stops on focus/input, restarts on blur when empty.
 */
(function () {
  'use strict';

  var PREFIX = 'Search for ';
  var WORDS = ['shirts', 'brands', 'tops', 'sneakers', 'dresses', 'jeans'];
  var LETTER_MS = 90;
  var PAUSE_FULL_MS = 1200;
  var CURSOR = '|';
  var BLUR_RESTART_MS = 160;

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function SkippSearchPlaceholderTyping(root) {
    this.root = root;
    this.input = root.querySelector('input[type="search"][name="q"]');
    this.staticPlaceholder =
      root.getAttribute('data-skipp-search-typing-static') ||
      (this.input && this.input.getAttribute('placeholder')) ||
      '';
    this.timer = null;
    this.wordIndex = 0;
  }

  SkippSearchPlaceholderTyping.prototype.clearTimer = function () {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  };

  SkippSearchPlaceholderTyping.prototype.schedule = function (fn, ms) {
    var self = this;
    this.clearTimer();
    this.timer = setTimeout(function () {
      self.timer = null;
      fn();
    }, ms);
  };

  SkippSearchPlaceholderTyping.prototype.shouldRun = function () {
    if (!this.input || prefersReducedMotion()) return false;
    if (document.activeElement === this.input) return false;
    var v = this.input.value;
    if (v != null && String(v).length > 0) return false;
    return true;
  };

  SkippSearchPlaceholderTyping.prototype.applyPlaceholder = function (suffix) {
    if (this.input) this.input.placeholder = PREFIX + suffix + CURSOR;
  };

  SkippSearchPlaceholderTyping.prototype.stop = function () {
    this.clearTimer();
    if (this.input && this.staticPlaceholder) {
      this.input.placeholder = this.staticPlaceholder;
    }
  };

  SkippSearchPlaceholderTyping.prototype.typeWord = function (word, i) {
    var self = this;
    if (!this.shouldRun()) {
      this.stop();
      return;
    }
    if (i < word.length) {
      this.applyPlaceholder(word.slice(0, i + 1));
      this.schedule(function () {
        self.typeWord(word, i + 1);
      }, LETTER_MS);
    } else {
      this.schedule(function () {
        self.eraseWord(word, word.length - 1);
      }, PAUSE_FULL_MS);
    }
  };

  SkippSearchPlaceholderTyping.prototype.eraseWord = function (word, i) {
    var self = this;
    if (!this.shouldRun()) {
      this.stop();
      return;
    }
    if (i >= 0) {
      this.applyPlaceholder(word.slice(0, i));
      this.schedule(function () {
        self.eraseWord(word, i - 1);
      }, LETTER_MS);
    } else {
      this.wordIndex = (this.wordIndex + 1) % WORDS.length;
      this.schedule(function () {
        self.loop();
      }, LETTER_MS);
    }
  };

  SkippSearchPlaceholderTyping.prototype.loop = function () {
    var self = this;
    if (!this.shouldRun()) {
      this.stop();
      return;
    }
    var word = WORDS[this.wordIndex % WORDS.length];
    if (!word) {
      this.wordIndex++;
      this.schedule(function () {
        self.loop();
      }, LETTER_MS);
      return;
    }
    this.applyPlaceholder('');
    this.schedule(function () {
      self.typeWord(word, 0);
    }, LETTER_MS);
  };

  SkippSearchPlaceholderTyping.prototype.start = function () {
    if (!this.input || prefersReducedMotion()) return;
    if (!this.shouldRun()) return;
    this.wordIndex = 0;
    this.clearTimer();
    this.loop();
  };

  SkippSearchPlaceholderTyping.prototype.bind = function () {
    var self = this;
    if (!this.input) return;

    this.input.addEventListener('focus', function () {
      self.stop();
    });

    this.input.addEventListener('input', function () {
      if (self.input.value && self.input.value.length > 0) {
        self.stop();
      }
    });

    this.input.addEventListener('blur', function () {
      self.schedule(function () {
        if (self.shouldRun()) self.start();
      }, BLUR_RESTART_MS);
    });

    function kickoffStart() {
      if (self.shouldRun()) self.start();
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(kickoffStart);
    });
  };

  function init() {
    document.querySelectorAll('[data-skipp-search-typing]').forEach(function (root) {
      if (root.getAttribute('data-skipp-search-typing-init') === 'true') return;
      root.setAttribute('data-skipp-search-typing-init', 'true');
      new SkippSearchPlaceholderTyping(root).bind();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
